import apiClient from './apiClient';
import {
  TriggerConfiguration,
  TriggerComplianceReport,
  TenantTriggerStatus
} from '../types/TriggerCompliance';

export const triggerApi = {
  // Configuration endpoints
  getConfigurations: async (): Promise<TriggerConfiguration[]> => {
    const response = await apiClient.get<TriggerConfiguration[]>('/api/TriggerCompliance/configurations');
    return response.data;
  },

  getConfiguration: async (id: number): Promise<TriggerConfiguration> => {
    const response = await apiClient.get<TriggerConfiguration>(`/api/TriggerCompliance/configurations/${id}`);
    return response.data;
  },

  createConfiguration: async (config: Partial<TriggerConfiguration>): Promise<TriggerConfiguration> => {
    const response = await apiClient.post<TriggerConfiguration>('/api/TriggerCompliance/configurations', config);
    return response.data;
  },

  updateConfiguration: async (id: number, config: Partial<TriggerConfiguration>): Promise<TriggerConfiguration> => {
    const response = await apiClient.put<TriggerConfiguration>(`/api/TriggerCompliance/configurations/${id}`, config);
    return response.data;
  },

  deleteConfiguration: async (id: number): Promise<void> => {
    await apiClient.delete(`/api/TriggerCompliance/configurations/${id}`);
  },

  // Compliance check endpoints
  checkAllTenants: async (): Promise<TriggerComplianceReport> => {
    const response = await apiClient.get<TriggerComplianceReport>('/api/TriggerCompliance/check');
    return response.data;
  },

  checkTenant: async (tenantId: number): Promise<TenantTriggerStatus> => {
    const response = await apiClient.get<TenantTriggerStatus>(`/api/TriggerCompliance/check/${tenantId}`);
    return response.data;
  },

  // Fix endpoints
  fixTenant: async (tenantId: number): Promise<{ message: string }> => {
    const response = await apiClient.post<{ message: string }>(`/api/TriggerCompliance/fix/${tenantId}`);
    return response.data;
  },

  fixAllTenants: async (): Promise<{ message: string }> => {
    const response = await apiClient.post<{ message: string }>('/api/TriggerCompliance/fix-all');
    return response.data;
  },
};

export default triggerApi;
